module.exports = __webpack_public_path__ + "img/LOA Explained Through a Credit Card.831af203.png";